export default __webpack_public_path__ + "static/media/config-hris-department.f9c18583.svg";